module.exports = __webpack_public_path__ + "static/media/Vertical_Bar_Graphs.2acc87bd.gif";